__turbopack_context__.v({
  "anchor": "mJt6Qq_anchor",
});
